export class CubeSide {
  public id: 'front' | 'back' | 'top' | 'bottom' | 'left' | 'right';
  public backgroundColor = '';
  public color = '';

  constructor(id: 'front' | 'back' | 'top' | 'bottom' | 'left' | 'right') {
    this.id = id;
  }
}
